import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { JeevesAddCustomerModalComponent } from 'gung-standard-jeeves';
import { Customer, AuthService, GungBase, TableRecord, GungModalService } from 'gung-standard';
import { catchError, forkJoin, throwError } from 'rxjs';
import { first } from 'rxjs';
import { ColmecCustomerService } from '../../services/colmec-customer.service';
import { HttpErrorResponse } from '@angular/common/http';
import { JsonViewModal } from 'gung-common';

@Component({
    selector: 'colmec-add-customer-modal',
    templateUrl: './colmec-add-customer-modal.component.html',
    styleUrls: ['./colmec-add-customer-modal.component.scss'],
    standalone: false
})
export class ColmecAddCustomerModalComponent extends JeevesAddCustomerModalComponent implements OnInit {
  alert: Alert;
  private defaultSalesPerson = '';

  @Input()
  customer: Customer;

  @Input()
  create = true;

  isAdmin: boolean;
  isSales: boolean;

  constructor(
    protected customerService: ColmecCustomerService,
    protected formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private authService: AuthService,
    protected modalService: GungModalService
  ) {
    super(activeModal, customerService, formBuilder, modalService);
  }

  ngOnInit() {
    forkJoin([this.authService.getCurrentUser().pipe(first()), this.authService.getRoles().pipe(first())]).subscribe(
      ([user, roles]) => {
        this.isAdmin = roles.indexOf('ADMIN') >= 0;
        this.isSales = !this.isAdmin && roles.indexOf('SALES') >= 0;

        const baseUser = user as unknown as GungBase;
        if (baseUser.extra.orderParams && baseUser.extra.orderParams.procargs) {
          this.defaultSalesPerson = baseUser.extra.orderParams.procargs.saljare || '';
        }

        if (this.create) {
          this.initForm();
        } else {
          if (this.isAdmin || this.isSales) {
            this.loadformAdmin();
          } else {
            this.loadform();
          }
        }
      }
    );
  }

  initForm() {
    this.customerForm = this.formBuilder.group({
      extra: this.formBuilder.group({
        fr: this.formBuilder.group({
          ftgnamn: this.formBuilder.control('', [Validators.required]),
          ftgpostadr1: this.formBuilder.control(''),
          ftgpostadr2: this.formBuilder.control(''),
          ftgpostadr5: this.formBuilder.control(''),
          ftgpostnr: this.formBuilder.control(''),
          ftglevpostnr: this.formBuilder.control(''),
          ftgpostadr3: this.formBuilder.control(''),
          ftgpostlevadr3: this.formBuilder.control(''),
          landskod: this.formBuilder.control(''),
          orgnr: this.formBuilder.control(''),
          comnr: this.formBuilder.control('')
        }),
        kus: this.formBuilder.group({
          levvillkkod: this.formBuilder.control('3'), //  Fritt ert lager - default value
          betkod: this.formBuilder.control(''),
          levsattkod: this.formBuilder.control(''),
          kundkategorikod: this.formBuilder.control('', [Validators.required]),
          saljare: this.formBuilder.control(this.defaultSalesPerson),
          prislista: this.formBuilder.control(''),
          valkod: this.formBuilder.control('SEK'), // SEK - default value
          momskod: this.formBuilder.control('1'), // 25% default value
          kundrabatt: this.formBuilder.control('', [
            Validators.min(0),
            Validators.max(100),
            Validators.pattern('^[0-9]*$')
          ]),
          q_email_invoice: this.formBuilder.control('', [Validators.email]),
          kundklass: this.formBuilder.control(''),
          edit: this.formBuilder.control('')
        })
      })
    });
  }

  loadform() {
    this.customerForm = this.formBuilder.group({
      extra: this.formBuilder.group({
        kus: this.formBuilder.group({
          kundrabatt: this.formBuilder.control(this.customer.extra.kus.kundrabatt),
          q_email_invoice: this.formBuilder.control(this.customer.extra.kus.q_email_invoice || '', [Validators.email]),
          kundklass: this.formBuilder.control(this.customer.extra.kus.kundklass),
          edit: this.formBuilder.control(this.customer.extra.kus.edit || '')
        }),
        fr: this.formBuilder.group({
          comnr: this.formBuilder.control(this.customer.extra.fr.comnr || '')
        })
      })
    });
  }

  loadformAdmin() {
    this.customerForm = this.formBuilder.group({
      extra: this.formBuilder.group({
        fr: this.formBuilder.group({
          ftgnamn: this.formBuilder.control(this.customer.extra.fr.ftgnamn, [Validators.required]),
          ftgpostadr1: this.formBuilder.control(this.customer.extra.fr.ftgpostadr1),
          ftgpostadr2: this.formBuilder.control(this.customer.extra.fr.ftgpostadr2),
          ftgpostadr5: this.formBuilder.control(this.customer.extra.fr.ftgpostadr5),
          ftgpostnr: this.formBuilder.control(this.customer.extra.fr.ftgpostnr),
          ftglevpostnr: this.formBuilder.control(this.customer.extra.fr.ftglevpostnr),
          ftgpostadr3: this.formBuilder.control(this.customer.extra.fr.ftgpostadr3),
          ftgpostlevadr3: this.formBuilder.control(this.customer.extra.fr.ftgpostlevadr3),
          landskod: this.formBuilder.control(this.customer.extra.fr.landskod),
          orgnr: this.formBuilder.control(this.customer.extra.fr.orgnr),
          comnr: this.formBuilder.control(this.customer.extra.fr.comnr || '')
        }),
        kus: this.formBuilder.group({
          levvillkkod: this.formBuilder.control(this.customer.extra.kus.levvillkkod),
          betkod: this.formBuilder.control(this.customer.extra.kus.betkod),
          levsattkod: this.formBuilder.control(this.customer.extra.kus.levsattkod),
          kundkategorikod: this.formBuilder.control(this.customer.extra.kus.kundkategorikod, []),
          saljare: this.formBuilder.control(this.customer.extra.kus.saljare),
          prislista: this.formBuilder.control(this.customer.extra.kus.prislista),
          valkod: this.formBuilder.control(this.customer.extra.kus.valkod),
          momskod: this.formBuilder.control(this.customer.extra.kus.momskod),
          kundrabatt: this.formBuilder.control(this.customer.extra.kus.kundrabatt, [
            Validators.min(0),
            Validators.max(100),
            Validators.pattern('^[0-9]*$')
          ]),
          q_email_invoice: this.formBuilder.control(this.customer.extra.kus.q_email_invoice || '', [Validators.email]),
          kundklass: this.formBuilder.control(this.customer.extra.kus.kundklass),
          edit: this.formBuilder.control(this.customer.extra.kus.edit || '')
        })
      })
    });
  }

  filterPaymentTerms(option: { key: string; value: string | TableRecord }): boolean {
    return option.key === '0' || option.key === '20' || option.key === '30';
  }

  filterCustomerCategories(option: { key: string; value: string | TableRecord }): boolean {
    return option.key === '10' || option.key === '3';
  }

  submitForm() {
    this.isSubmitted = true;
    this.customerForm.markAllAsTouched();
    // this.customerForm.disable(); // Make it readonly
    if (this.create) {
      if (this.customerForm.invalid) {
        this.alert = {
          type: 'warning',
          message: 'CUSTOMER_CREATE_FORM_ERROR'
        };
        this.isSubmitted = false;
        return;
      }

      const customer: Customer = { ...this.customerForm.getRawValue() };
      this.customerService
        .createNewCustomer(customer)
        .pipe(
          catchError((error: HttpErrorResponse, caught) => {
            const data: JsonViewModal = {
              title: 'ERROR',
              subTitle: error.error.status,
              json: error.error.gungMessage || error.error.message,
              typeString: true
            };

            this.modalService.openJSONModal(data);
            return throwError(() => error);
          })
        )
        .subscribe({
          next: customers => {
            const result = { customers };
            this.isSubmitted = false;
            this.customerService.updateCustomersSubject(true);
            this.activeModal.close(result);
          },
          error: error => {
            this.alert = {
              type: 'danger',
              message: 'CUSTOMER_CREATE_ERROR'
            };
            this.isSubmitted = false;
          }
        });
    } else {
      if (this.customerForm.invalid) {
        this.customerForm.markAllAsTouched();
        this.alert = {
          type: 'warning',
          message: 'CUSTOMER_UPDATE_FORM_ERROR'
        };
        this.isSubmitted = false;
        return;
      }

      const updatedCustomer: Customer = { id: this.customer.id, ...this.customerForm.getRawValue() };
      this.customerService.updateCustomer(updatedCustomer).subscribe(
        customer => {
          this.isSubmitted = false;
          this.customerService.updateCurrentCustomerSubject(updatedCustomer.id, true);
          this.customerForm.reset();
          this.activeModal.close(customer || updatedCustomer);
        },
        error => {
          this.alert = {
            type: 'danger',
            message: 'CUSTOMER_UPDATE_ERROR'
          };
          this.isSubmitted = false;
        }
      );
    }
  }
}

interface Alert {
  type: string;
  message: string;
}
